import { render, staticRenderFns } from "./_dangerZoneCorner.vue?vue&type=template&id=80bb1d3a&lang=pug&"
import script from "./_dangerZoneCorner.vue?vue&type=script&lang=js&"
export * from "./_dangerZoneCorner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports